__turbopack_context__.v({
  "aCell": "TableFAQ-module__UUt0zW__aCell",
  "desktopOnly": "TableFAQ-module__UUt0zW__desktopOnly",
  "divider": "TableFAQ-module__UUt0zW__divider",
  "ma": "TableFAQ-module__UUt0zW__ma",
  "mobileGap": "TableFAQ-module__UUt0zW__mobileGap",
  "mobileItem": "TableFAQ-module__UUt0zW__mobileItem",
  "mobileOnly": "TableFAQ-module__UUt0zW__mobileOnly",
  "mq": "TableFAQ-module__UUt0zW__mq",
  "qCell": "TableFAQ-module__UUt0zW__qCell",
  "section": "TableFAQ-module__UUt0zW__section",
  "table": "TableFAQ-module__UUt0zW__table",
  "tableSpacer": "TableFAQ-module__UUt0zW__tableSpacer",
  "title": "TableFAQ-module__UUt0zW__title",
});
